'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './journal-entries.routes';

export class JournalEntriesComponent {

  constructor(AccountingService, dialogs) {
    'ngInject';

    this.AccountingService = AccountingService;
    this.dialogs = dialogs;

    this.AccountingService.journal({book: 'test'}, data => {
      this.journal = data;
    });
  }

  showId(id) {
    prompt('Journal ID',id);
  }

  voidEntry(entry) {
    var that = this;

    var text = "<br/> <br/>" +
      "<table class='table' style='width:100%'>" +
        "<thead>" +
          "<tr>" +
            "<th>Account</th>" +
            "<th>Credit</th>" +
            "<th>Debit</th>" +
            "<th>Memo</th>" +
            "</tr>" +
          "</thead>" +
          "<tbody>";

    entry._transactions.forEach(tx => {
      text +=
              "<tr>" +
                "<td>"+tx.accounts+"</td>" +
                "<td>"+tx.credit+"</td>" +
                "<td>"+tx.debit+"</td>" +
                "<td>"+tx.memo+"</td>" +
              "</tr>";
    });

    text +=
            "</tbody>" +
        "</table>";

    var dlg = this.dialogs.confirm("Void Journal Entry?", "Do you really want to void the journal entry?" + text);
    dlg.result.then(() => {
      // OK delete it
      that.AccountingService.void({book: 'test', id: entry._id}, {},
        () => {
          this.AccountingService.journal({book: 'test'}, data => {
            this.journal = data;
          });
        },
        err => {
          alert("Could not void journal entry");
        });
    }, () => {
      // Cancel
    });
  }
}

export default angular.module('conduuApp.journalEntries', [uiRouter])
  .config(routes)
  .component('journalEntries', {
    template: require('./journal-entries.html'),
    controller: JournalEntriesComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/accounting/journal-entries/journal-entries.component.js